(function () {
    'use strict';

    angular.module('app', [
        'app.core',
        'app.layout',
        'app.user',
        'app.truck',
        'app.application',
        'app.sso',
        'app.region',
        'app.audit',
        'app.widgets',
        'app.settings'
    ]);

})();
